import styled from "styled-components";
import { Divider } from "@ebscois/react-component-library";

export const StyledDivider = styled(Divider)`
  margin: 10px 0;
`;
